import React from 'react';
import styles from './circle-button.scss';
export class CircleButton extends React.Component {
    render() {
        const { children, borderWidth = 2 } = this.props;
        return (React.createElement("div", { style: {
                borderWidth,
            }, className: styles.circleButton }, children));
    }
}
//# sourceMappingURL=circle-button.js.map